import React, { useState } from 'react';
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
import { useAuth } from "../Common/Configurations/AuthContext";
import DefaultData from '../CompanyData/DefaultData';

const initialLoginValues = {
    username: '',
    password: '',
    companyId: '00000000-0000-0000-0000-000000000000',
};

export default function LoginModal({ show, onClose, onSwitchToRegister, onSwitchToForgotPassword }) {
    const { login } = useAuth();
    const [values, setValues] = useState(initialLoginValues);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!values.username || !values.password) {
            setError('Please enter both username and password.');
            return;
        }

        setIsLoading(true);
        setError(''); // Clear previous errors

        const formData = {
            "username": values.username,
            "password": values.password,
            "companyId": DefaultData.DEFAULTCOMPANYID
        };

        try {
            const result = await apiService.post(config.LOGIN, formData);
            if (result.accessToken) {
                login({
                    accessToken: result.accessToken,
                    refreshToken: result.refreshToken,
                });
                onClose();
                setValues(initialLoginValues);
            } else {
                setError('Invalid username or password.');
            }
        } catch (err) {
            setError('Login failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    if (!show) {
        return null;
    }

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Sign In</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            <p className="text-muted text-center">Sign in to continue your journey.</p>
                            {error && <div className="alert alert-danger">{error}</div>}
                            <form onSubmit={handleSubmit} noValidate>
                                <div className="mb-3">
                                    <label htmlFor="login-username" className="form-label">Username</label>
                                    <input className="form-control" id="login-username" name="username" type="text" value={values.username} onChange={handleInputChange} placeholder="Enter Username" />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="login-password">Password</label>
                                    <div className="position-relative">
                                        <input
                                            className="form-control"
                                            id="login-password"
                                            name="password"
                                            type={showPassword ? 'text' : 'password'}
                                            value={values.password}
                                            onChange={handleInputChange}
                                            placeholder="Password"
                                        />
                                        <span className="password-toggle-icon" onClick={() => setShowPassword(!showPassword)}>
                                            <i className={showPassword ? "ri-eye-fill" : "ri-eye-off-fill"}></i>
                                        </span>
                                    </div>
                                </div>
                                 <div className="d-flex justify-content-end mb-3">
                                    <button 
                                        type="button" 
                                        className="btn btn-link p-0 text-muted"
                                        onClick={onSwitchToForgotPassword}
                                    >
                                        Forgot Password?
                                    </button>
                                </div>
                                <div className="mt-4">
                                    <button type="submit" className="btn btn-success w-100" disabled={isLoading}>
                                        {isLoading ? 'Signing In...' : 'Sign In'}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <p className="mb-0">
                                Don't have an account?{' '}
                                <button className="btn btn-link p-0 fw-semibold text-decoration-underline" onClick={onSwitchToRegister}>
                                    Register
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}